import React from 'react';
import { Col, Input, Select, Tooltip } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useOverviewLinkStateActions } from '../hooks/useOverviewLinkStateActions';
import { allRequestBookingStatusTypes } from '../../../shared/types';
import { useOverviewLinkState } from '../linkstate/requestBookingOverview.linkstate';

export const RequestBookingFilter = () => {
    const [{ search, selectedRequestBookingStatus }] = useOverviewLinkState();
    const { patch: patchState } = useOverviewLinkStateActions();

    return (
        <>
            <Col style={{ width: 300 }}>
                <Input
                    value={search}
                    placeholder={'Search by name, email, Contact No'}
                    onChange={(e) => patchState({ search: e.target.value })}
                    addonBefore={<SearchOutlined />}
                />
            </Col>
            <Col style={{ width: 200 }}>
                <Tooltip
                    title={`Filter by Status: ${(selectedRequestBookingStatus ?? []).map((type) => `#${type}`).join(' ')}`}
                >
                    <Select
                        placeholder="Status of Request Booking"
                        mode="multiple"
                        value={selectedRequestBookingStatus ?? []}
                        style={{ width: '100%', height: 32 }}
                        maxTagCount={1}
                        maxTagTextLength={10}
                        onChange={(e) => patchState({ selectedRequestBookingStatus: e })}
                    >
                        {(allRequestBookingStatusTypes ?? []).map((type) => (
                            <Select.Option key={type} value={type}>
                                {type}
                            </Select.Option>
                        ))}
                    </Select>
                </Tooltip>
            </Col>
        </>
    );
};
